import clsx from 'clsx';

import styles from './ModuleAnnotationsStyles.css';

export type AnnotationsMarkerProps = {
  label: string;
};

export const AnnotationsMarker = ({ label }: AnnotationsMarkerProps) => (
  <div className={clsx(styles.marker, 'c-annotations__marker')}>
    <div className={clsx(styles.markerLabel, 'c-annotations__marker-label')}>{label}</div>
  </div>
);
